import { useState } from "@hookstate/core";
import { state } from "./state";

export const useSearchFilters = () => {
  return useState(state);
};
